module.exports = {

	buildDataTablesColumns: function(colData){
    var columns = [];

    $.each(colData, function(i, el){
      var options = {
        title: el.title,
        autoWidth: false
      };

      if(typeof el.className !== 'undefined')
        options.className = el.className;

      if(el.noSort)
        options.orderable = false;

      if(el.noSearch)
        options.searchable = false;

      if(typeof el.width !== 'undefined')
        options.width = el.width;
      // else
      //   options.width = '10%';

      columns.push(options);
    });

    return columns;
  },

  formatResultsData: function(results, colData){
    var data = [];

    $.each(results, function(i, result){
      var newResult = [];

      $.each(colData, function(j, col){
        var val;

        if(typeof col.func !== 'undefined'){
          val = col.func(result);
        }else if(typeof col.format !== 'undefined'){
          switch(col.format){
            case 'joinBreak':
              val = result[col.prop].join('<br>');
            break;

            case 'toFixed':
              val = Number(result[col.prop]).toFixed(2);
            break;
          }
        }else if(typeof(col.prop) !== 'undefined'){
          val = typeof result[col.prop] !== 'undefined' ? result[col.prop] : '';
        }else{
          console.error('Bad colData config:', col );
        }

        newResult.push(val);
      });

      data.push(newResult);
    });

    return data;

  }
};